// import { Language } from '@prisma/client';
import { CONTENTFUL_ENGLISH_KEY, ContentfulProduct } from '@web/common';

export function getProductData(data: ContentfulProduct) {
  const title = data.fields.title[CONTENTFUL_ENGLISH_KEY];
  const amount = data.fields.amount[CONTENTFUL_ENGLISH_KEY];
  const thcLevel = data.fields.thcLevel[CONTENTFUL_ENGLISH_KEY];
  const thcPercentage = data.fields.thcPercentage
    ? data.fields.thcPercentage[CONTENTFUL_ENGLISH_KEY]
    : undefined;
  const cbdPercentage = data.fields.cbdPercentage
    ? data.fields.cbdPercentage[CONTENTFUL_ENGLISH_KEY]
    : undefined;
  const producer = data.fields.producer[CONTENTFUL_ENGLISH_KEY];
  const strainDominance = data.fields.strainDominance
    ? data.fields.strainDominance[CONTENTFUL_ENGLISH_KEY]
    : undefined;
  const price = data.fields.price[CONTENTFUL_ENGLISH_KEY];
  const image = data.fields.image
    ? data.fields.image[CONTENTFUL_ENGLISH_KEY].fields.file[
        CONTENTFUL_ENGLISH_KEY
      ].url
    : undefined;
  const type = data.fields.type[CONTENTFUL_ENGLISH_KEY];
  const amountPerUnit = data.fields.amountPerUnit
    ? data.fields.amountPerUnit[CONTENTFUL_ENGLISH_KEY]
    : undefined;

  return {
    title,
    amount,
    thcLevel,
    thcPercentage,
    cbdPercentage,
    producer,
    strainDominance,
    price,
    image,
    type,
    amountPerUnit,
  };
}
